import ReactSlider from 'rc-slider';

import '../../scss/shared.scss';

export type RangeSliderProps = {
  min: number;
  max: number;
  step?: number;
  value: [number, number] | number;
  onChange: (values: number[]) => void;
};

const RangeSlider: React.FC<RangeSliderProps> = (props) => {
  const { min, max, step = 1, onChange, value } = props;

  const handleChange = (values: number | number[]) => {
    if (Array.isArray(values)) {
      onChange(values);
    }
  };

  return (
    <ReactSlider
      min={min}
      max={max}
      step={step}
      value={value}
      range
      marks={{ [min]: ' ', [max]: ' ' }}
      onChange={handleChange}
      className='slider'
    />
  );
};

export default RangeSlider;
